<template>
  <b-form @submit="onSubmit" @reset="onReset">

    <b-form-group :label-size="size" label="Аудитория" label-for="audienct-selector" label-class="mb-0">
      <b-form-select
        id="audienct-selector"
        v-model="internalSelectedAudienceId"
        :options="audienceOptions"
        :disabled="audienceSelectorDisabled"
        :size="size"
      />
    </b-form-group>

    <b-form-group :label-size="size" label="Уровни">
      <b-input-group>
        <b-form-input type="number" :size="size" v-model="startLevelStr" min="1"></b-form-input>
        <span> - </span>
        <b-form-input type="number" :size="size" v-model="endLevelStr" min="1"></b-form-input>
      </b-input-group>
    </b-form-group>
    <b-button :size="size" type="submit" variant="primary">Загрузить</b-button>
    <b-button :size="size" type="reset" variant="danger">Сбросить</b-button>
  </b-form>
</template>

<script>
import { parseOptionalUint32Input             } from '../../util.js';
import { convertOptionalValueToOptionalString } from '../../util.js';
import { getAudienceName                      } from '../../model/m3level.js';

export default {
  name: 'M3LevelsFilter',

  props: {
    audienceIds: {
      type: Array,
      default: null,
    },

    audienceId: {
      type: Number,
      default: null,
    },

    startLevel: {
      type: Number,
      default: null,
    },

    endLevel: {
      type: Number,
      default: null,
    },

    size: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      /** @type {?number} */
      internalSelectedAudienceId: this.audienceId,

      startLevelStr: convertOptionalValueToOptionalString(this.startLevel),
      endLevelStr:   convertOptionalValueToOptionalString(this.endLevel),
    };
  },

  computed: {
    /** @returns {Object[]} */
    audienceOptions() {
      const DEFAULT_AUDIENCE_ID = null;

      const options = [
        {value: DEFAULT_AUDIENCE_ID, text: getAudienceName(DEFAULT_AUDIENCE_ID)},
      ];

      if(this.audienceIds === null) {
        return options;
      }

      for(const audienceId of this.audienceIds) {
        const option = {
          value: audienceId,
          text:  getAudienceName(audienceId),
        };
        options.push(option);
      }
      return options;
    },

    /** @returns {boolean} */
    audienceSelectorDisabled() {
      return this.audienceIds === null || this.audienceIds.length === 0;
    }
  },

  watch: {
    audienceIds() {
      if(this.audienceIds === null || this.audienceIds.length === 0) {
        this.internalSelectedAudienceId = null;
      }
    },

    audienceId(newAudienceId) {
      if(this.internalSelectedAudienceId !== newAudienceId) {
        this.internalSelectedAudienceId = newAudienceId;
      }
    },

    startLevel(newStartLevel) {
      const newStartLevelStr = convertOptionalValueToOptionalString(newStartLevel);
      if(newStartLevelStr !== this.startLevelStr) {
        this.startLevelStr = newStartLevelStr;
      }
    },

    endLevel(newEndLevel) {
      const newEndLevelStr = convertOptionalValueToOptionalString(newEndLevel);
      if(newEndLevelStr !== this.endLevelStr) {
        this.endLevelStr = newEndLevelStr;
      }
    },
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();

      const startLevelParsingReport = this.parseStartLevel();
      if(startLevelParsingReport.error !== null) {
        this.$emit('error', startLevelParsingReport.error);
        return;
      }
      const startLevel = startLevelParsingReport.n;

      const endLevelParsingReport = this.parseEndLevel();
      if(endLevelParsingReport.error !== null) {
        this.$emit('error', endLevelParsingReport.error);
        return;
      }
      const endLevel = endLevelParsingReport.n;

      this.$emit('loading-selected', this.internalSelectedAudienceId, startLevel, endLevel);
    },

    onReset(event) {
      event.preventDefault();
      this.internalSelectedAudienceId = null;
      this.startLevelStr = null;
      this.endLevelStr = null;
    },

    parseStartLevel() {
      const parsingReport = parseOptionalUint32Input(this.startLevelStr);
      if(parsingReport.error !== null) {
        return {
          n: null,
          error: new Error(`String start level '${this.startLevelStr}' is invalid. ` + parsingReport.error.toString()),
        };
      }
      return parsingReport;
    },
  
    parseEndLevel() {
      const parsingReport = parseOptionalUint32Input(this.endLevelStr);
      if(parsingReport.error !== null) {
        return {
          n: null,
          error: new Error(`String end level '${this.endLevelStr}' is invalid. ` + parsingReport.error.toString()),
        };
      }
      return parsingReport;
    },
  },
}
</script>
